// v48b — the Creator Grid's star + "Prioritize Favorites" toggle, shared by
// the X Creators list/profile and My Radar pipelines (same look and feel).
import { Star } from "lucide-react";

export function StarButton({ on, onToggle, testid, size = 14 }) {
  return (
    <button
      type="button"
      data-testid={testid}
      data-active={on ? "true" : "false"}
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); onToggle(); }}
      className="p-1 -m-1 inline-flex items-center justify-center transition-transform duration-150 hover:scale-110"
      title={on ? "Remove from favorites" : "Add to favorites"}
      aria-label={on ? "Remove from favorites" : "Add to favorites"}
    >
      <Star size={size} strokeWidth={1.8} fill={on ? "#FBBF24" : "none"} style={{ color: on ? "#FBBF24" : "#71717A" }} />
    </button>
  );
}

export function PrioritizeToggle({ on, onToggle, count, testid = "prioritize-favorites-toggle" }) {
  return (
    <button
      type="button"
      data-testid={testid}
      data-active={on ? "true" : "false"}
      onClick={onToggle}
      title={`${on ? "Disable" : "Enable"} favorites prioritization`}
      className="text-xs px-2.5 py-1.5 rounded-md border inline-flex items-center gap-1.5 transition-colors duration-150"
      style={on
        ? { background: "rgba(251,191,36,0.15)", borderColor: "rgba(251,191,36,0.55)", color: "#FBBF24" }
        : { background: "var(--surface)", borderColor: "rgba(255,255,255,0.1)", color: "#A1A1AA" }}
    >
      <Star size={12} fill={on ? "#FBBF24" : "none"} /> Prioritize Favorites
      {count > 0 && <span className="mono text-[10px]">({count})</span>}
    </button>
  );
}

// Starred first, keeping each group's existing order.
export function starredFirst(rows, has, idOf) {
  const a = [];
  const b = [];
  rows.forEach((r) => (has(idOf(r)) ? a : b).push(r));
  return a.concat(b);
}
